import type { Component } from 'vue';
import HeaderMedia from '~/components/header-modules/HeaderMedia.vue';
import HeaderContact from '~/components/header-modules/HeaderContact.vue';
import HeaderDefault from '~/components/header-modules/HeaderDefault.vue';

export const HeaderModuleComponents: Record<string, Component> = {
  HeaderDefaultRecord: HeaderDefault,
  HeaderMediumRecord: HeaderMedia,
  HeaderContactRecord: HeaderContact,
};
